import { SharedState } from '@trello/shared-state';

interface BoardSwitcherSharedState {
  isOpen: boolean;
  isSpotlightOpen: boolean;
  query: string | null;
  searchFieldRef: React.RefObject<HTMLInputElement> | null;
  selectedWorkspaceId: string | null;
}

export const defaultBoardSwitcherSharedState: BoardSwitcherSharedState = {
  isOpen: false,
  isSpotlightOpen: false,
  query: null,
  searchFieldRef: null,
  selectedWorkspaceId: null,
};

export const boardSwitcherSharedState = new SharedState(
  defaultBoardSwitcherSharedState,
);
